export default __webpack_public_path__ + "static/media/ganar.aea99ec5.png";